import type { IconRuleSet } from '@vfuk/core-icon-generator'
import type { Theme } from '@vfuk/core-themes'

// Setting up nonThemeableRules for use within the React component generator
export const nonThemeableRules: IconRuleSet = {
  packageName: 'BrandLoFiIcons',
  colorAppliesTo: 'fill',
  defaultSize: 3,
  hasNumberBadge: false,
  widthOverride: 'auto',
  size: {
    1: {
      sm: 16,
      md: 16,
      lg: 16,
      xl: 16,
    },
    2: {
      sm: 16,
      md: 24,
      lg: 24,
      xl: 24,
    },
    3: {
      sm: 24,
      md: 32,
      lg: 32,
      xl: 32,
    },
    4: {
      sm: 24,
      md: 32,
      lg: 40,
      xl: 40,
    },
    5: {
      sm: 32,
      md: 40,
      lg: 48,
      xl: 48,
    },
  },
  appearance: {
    primary: {
      color: '',
      inverse: {
        color: '',
      },
    },
  },
}

const ruleSet = (theme: Theme): IconRuleSet => {
  const rules = JSON.parse(JSON.stringify(nonThemeableRules))
  rules.appearance = {
    primary: {
      inverse: {
        color: theme.inverseColor.monochrome6.default,
      },
    },
  }
  return rules
}

export default ruleSet
